<div class="row my-row">

    <aside class="col-md-3 my-col" id="sticky-sidebar">
        <app-folders></app-folders>
    </aside>

    <div class="col-12 col-md-9 my-col" id="main">
        <app-error [error_message]="errorMessage" [error_type]="errorType"></app-error>

        <div class="row my-row pt-5 pb-3">
            <div class="col-xl my-col">
                <h1>{{ "CREATE.TITLE" | translate }}</h1>
            </div>
        </div>
    
        <div class="row my-row">
            <div class="col my-col">
                <div class="card-body">
                    <form [formGroup]="messageForm" autocomplete="off" novalidate>
                        <div class='form-row align-items-center mb-3 my-row'>
                            <div class='col-8 col-xl-7 pb-3 my-col'>
                                <label for="destinataire">{{ "CREATE.FORM.SIGNATORIES" | translate }} :</label>
                                <input type="text" readonly class="form-control" placeholder="{{ 'CREATE.FORM.SIGNATORIES' | translate }}" 
                                    formControlName="destinataire" id="destinataire" (click)="directory()">
                            </div>
                            <div class='col-auto pt-3 my-col'>
                                <button type="button" class="btn btn-success" (click)="directory()">{{ "BUTTONS.ADD-SIGNATORY" | translate }}</button>
                            </div>
                            <div class='col-auto pt-3 my-col'>
                                <mat-error *ngIf="hasError('destinataire', 'required')">{{ "ERRORS.SIGNATORY-REQUIRED" | translate }}</mat-error>
                            </div>
                        </div>
                        <div class='form-row align-items-center mb-3 my-row'>
                            <div class='col-12 pb-3 my-col'>
                                <div class="form-group">
                                    <label for="objet">{{ "CREATE.FORM.SUBJECT" | translate }} :</label>
                                    <input type="text" class="form-control" placeholder="{{ 'CREATE.FORM.SUBJECT' | translate }}" formControlName="objet" id="objet">
                                </div>
                            </div>
                        </div>
                        
                        <div class='form-row mb-3 my-row'>
                            <div class='col-12 pb-3 my-col'>
                                <div class="form-group">
                                    <label for="content">{{ "CREATE.FORM.CONTENT" | translate }}</label>
                                    <editor id="content" [init]="{
                                        base_url: '/tinymce',
                                        suffix: '.min',
                                        height: 200,
                                        menubar: false,
                                        plugins: [
                                            'advlist autolink lists link image charmap print preview anchor',
                                            'searchreplace visualblocks code fullscreen',
                                            'insertdatetime media table paste code wordcount'
                                        ],
                                        toolbar:
                                        'undo redo | formatselect | bold italic backcolor | \
                                        alignleft aligncenter alignright alignjustify | \
                                        bullist numlist outdent indent | removeformat'
                                    }" formControlName="content">
                                    </editor>
                                    <mat-error *ngIf="hasError('content', 'required')">{{ "ERRORS.CONTENT-REQUIRED" | translate }}</mat-error>
                                </div>
                            </div>
                        </div>
                        
                        <div class='form-row mb-3 my-row'>
                            <div class='col-12 pb-3 my-col'>
                                <div class="alert alert-info alert-dispissible fade show" role="alert">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <p [innerHtml]=" 'CREATE.FORM.ATTACHMENTS-INFO' | translate "></p> 
                                </div>
                                <div class="form-group">
                                    <div>
                                        <label for="attachments" class="btn btn-secondary">{{ "BUTTONS.ADD-FILE" | translate }}</label>
                                        <input type="file" #fileInput multiple="multiple" style="visibility: hidden;"
                                        accept=".txt, .pdf, .docx, .doc, .csv, .xls, .xlsx, .doc, .jpg, .png, .jpeg, .gif, .bmp, image/*"
                                        (change)="addAttachments(fileInput)" id="attachments" formControlName="attachments">
                                    </div>
                                    <ul>
                                        <li *ngFor="let attachment of this.attachmentsArray; let index = index">
                                            <span>{{ attachment.name }}</span>
                                            <em class="bi bi-x-circle-fill mx-2" style="color: red" (click)="removeAttachment(index)"></em>
                                        </li>
                                    </ul>
                                    <label for="progressBar">{{ "CREATE.FORM.SIZE" | translate }}</label>
                                    <div class="progress">
                                        <div id="progress-bar" class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;">
                                        0%
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>   
                    </form>
        
                    <div class="form mt-2">
                        <button *ngIf="userService.currentUser.symfonyUser.clients.length == 1" type="button" class="btn btn-primary"
                                [disabled]="!messageForm.valid" (click)="send(messageForm.value,userService.currentUser.symfonyUser.clients[0])">
                                {{ "BUTTONS.SEND" | translate }}
                        </button>
            
                        <button *ngIf="userService.currentUser.symfonyUser.clients.length > 1" type="button" class="btn btn-primary" 
                                [disabled]="!messageForm.valid" (click)="open(content)">
                                {{ "BUTTONS.CHOOSE-CLIENT" | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">{{ "CREATE.MODAL-CLIENT.TITLE" | translate }}</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div *ngIf="!clients">
            <p>{{ "CREATE.MODAL-CLIENT.CHOOSE-CLIENT" | translate }}</p>
        </div>
        <select [(ngModel)]="clients"> 
            <option *ngFor="let client of userService.currentUser.symfonyUser.clients" [ngValue]="client">
                {{client.name}}
            </option>
        </select>
        <div *ngIf="clients">
            <p>{{ "CREATE.MODAL-CLIENT.SELECTED-CLIENT" | translate }} {{clients.name}}</p>
        </div>
    </div>
    <div class="modal-footer">
        <button mat-raised-button color="primary" [disabled]="!clients" (click)="send(messageForm.value,clients);modal.close()">{{ "BUTTONS.SEND" | translate }}</button>
    </div>
</ng-template>